import { render } from "./workflowphase-overview.vue?vue&type=template&id=11c53352"
import script from "./workflowphase-overview.vue?vue&type=script&lang=js"
export * from "./workflowphase-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__